import React from "react";
import DataRetentionSettings from "../../components/admin/DataRetentionSettings";

/**
 * 관리자 > 데이터 보관 정책
 *
 * 자료 종류마다 얼마나 보관할지 고객사가 직접 정한다.
 * 저장하면 서버 재시작 없이 다음 정리 주기부터 그 값이 적용된다.
 */
export default function AdminRetentionPage() {
  return (
    <div className="h-full min-h-0 overflow-y-auto pr-1">
      <div className="space-y-4">
        <div>
          <h2 className="text-xl font-bold text-gray-900 dark:text-white">
            데이터 보관 정책
          </h2>
          <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
            정한 기간이 지난 영상·사진·기록은 자동으로 삭제됩니다.
          </p>
        </div>

        <DataRetentionSettings />

        <div className="rounded-2xl border border-gray-200 bg-white p-5 text-sm leading-relaxed text-gray-600 shadow-sm dark:border-gray-700 dark:bg-[#1F2A3B] dark:text-gray-300">
          <div className="mb-2 font-bold text-gray-900 dark:text-white">알아두실 점</div>
          <ul className="list-disc space-y-1.5 pl-5">
            <li>
              기간을 <b>줄이면</b> 그보다 오래된 자료는 다음 정리 때 삭제되며,
              <b> 되돌릴 수 없습니다.</b>
            </li>
            <li>
              <b>영상·사진이 지워져도 「위반 이력」은 남습니다.</b> 누가 언제 무엇을
              착용하지 않았는지는 기록으로 확인할 수 있습니다.
            </li>
            <li>
              <b>AI 학습용으로 수집한 이미지는 삭제하지 않습니다.</b> 현장 사진이 쌓일수록
              검출 정확도가 올라가는 구조라, 지우면 개선이 멈춥니다.
            </li>
            <li>
              정리는 <b>주기적으로 자동 실행</b>됩니다. 「지금 정리 실행」은 설정을 바꾼 뒤
              바로 확인하고 싶을 때만 쓰시면 됩니다.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
